import { wrap } from "svelte-spa-router/wrap";
import Splash from "./Splash.svelte";
import Prescription from "./Prescription.svelte";
import LensPicker from "./LensPicker.svelte";
import UpgradePicker from "./UpgradePicker.svelte";
import OptionsPicker from "./OptionsPicker.svelte";
import Results from "./Results.svelte";
import AntiFogAdaptive from "./lens-variants/AntiFogAdaptive.svelte";
import AntiFog from "./lens-variants/AntiFog.svelte";
import EasyCleanPlusBlue from "./lens-variants/EasyCleanPlusBlue.svelte";
import AntiReflectionPlus from "./lens-variants/AntiReflectionPlus.svelte";
import Polarised from "./lens-variants/Polarised.svelte";
import TintUV from "./lens-variants/TintUV.svelte";
import ContactLenses from "./ContactLenses.svelte";
import ContactLensesStep2 from "./ContactLensesStep2.svelte";
import ContactLensPicker from "./ContactLensPicker.svelte";
import ContactLensFaqs from "./ContactLensFaqs.svelte";
import ContactLensSubscription from "./ContactLensSubscription.svelte";
import ContactLensDetails from "./ContactLensDetails.svelte";
import NotFound from "./NotFound.svelte";
import Transitions from "./lens-variants/Transitions.svelte";
import TransitionsXtra from "./lens-variants/TransitionsXtra.svelte";
import Stellest from "./Stellest.svelte";
import OxfordStreet from "./OxfordStreet.svelte";

export const routes = {
	"/": Splash,
	"/prescription/:type?": Prescription,
	"/contact-lenses/": ContactLenses,
	"/contact-lenses/step2/": ContactLensesStep2,
	"/contact-lenses/lenses/": ContactLensPicker,
	"/contact-lenses/faqs/": ContactLensFaqs,
	"/contact-lenses/subscription/": ContactLensSubscription,
	"/contact-lenses/details/:lens/": ContactLensDetails,
	"/not-found/": NotFound,
	"/lens/": LensPicker,
	"/options/": OptionsPicker,
	"/upgrades/": UpgradePicker,
	"/upgrades/options/": wrap({
		component: OptionsPicker,
		props: { showUpgradeTiers: true },
	}),
	"/detail/transitions/": Transitions,
	"/detail/transitions-xtractive": TransitionsXtra,
	"/detail/anti-reflection-plus/": AntiReflectionPlus,
	"/detail/anti-fog-adaptive/": AntiFogAdaptive,
	"/detail/anti-fog/": AntiFog,
	"/detail/easy-clean-plus-blue/": EasyCleanPlusBlue,
	"/detail/polarised/": Polarised,
	"/detail/tint-uv/": TintUV,
	"/showcase/stellest": Stellest,
	"/showcase/oxford-street": OxfordStreet,
	"/results/": Results,
	"*": Splash,
};
